// extracted by mini-css-extract-plugin
export var lg = "_3f-4";
export var md = "_3f-3";
export var sm = "_3f-2";
export var xs = "_3f-1";
export var xxs = "_3f-0";